export const TEMARIO_DEPTH_LABELS = ["Bloque", "Tema", "Unidad"];
